// Local preview override for the redesigned cohort page, independent of the
// org admin setting. Enable in the browser console with:
//   localStorage.setItem('newCohortDesign', '1')  // then refresh
export const isNewCohortDesignDevOverride = (): boolean => {
  if (typeof window === 'undefined') return false
  try {
    return window.localStorage.getItem('newCohortDesign') === '1'
  } catch {
    return false
  }
}
